// Styles
import "./chat.scss";
// Tools
import { useMemo } from "react";
// Components
import { Dialog } from "./components/dialog/Dialog";
import { Form } from "./components/form/Form";
import { History } from "./components/history/History";
// Store
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../shared/store/store";
// Utils
import filterModules from "../../utils/module-utils/filter-modules-by-section";
import { getModulesWeights } from "../../utils/module-utils/get-modules-weights";
import { getModulesFromStorage } from "../../utils/module-utils/get-modules-from-storage";
import { SplitPane } from "../../utils/split-pane/splitPane";
import { CampaignWizardFormProvider } from "./utils/campaign-wizard-form.provider";

export const Chat = () => {
	// Все окна категории Chat
	const allPanes = [
		<History key='chat_history' />,
		<Dialog key='chat_window' />,
		<Form key='chat_form' />,
	].filter(Boolean);

	/* 
		Попробуем взять конфиг из localStorage — если его нет или он некорректный,
		используем конфиг из стора (appModulesConfig)
	*/
	const appModulesConfig = useSelector(
		(state: RootState) => state.app.modulesConfig,
	);
	const layoutHardResetNonce = useSelector(
		(state: RootState) => state.app.layoutHardResetNonce,
	);
	const modulesConfigFromStorage = getModulesFromStorage();
	// Сначала берем из localStorage, потом из appModulesConfig
	const modulesConfigToUse = modulesConfigFromStorage ?? appModulesConfig;

	// Список модулей в правильном порядке согласно moduleOrder
	const panes = filterModules(
		"chat",
		allPanes,
		modulesConfigToUse ?? undefined,
	);

	// Сигнатуры для ререндера компонента
	const modSig = JSON.stringify(modulesConfigToUse ?? []);
	const paneKeysSig = panes
		.map((p) => String((p as React.ReactElement)?.key ?? ""))
		.join(",");

	// Расчет процентов ширины
	const initialPercents = useMemo(
		() => getModulesWeights(modulesConfigToUse ?? undefined, panes),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[modSig, paneKeysSig, layoutHardResetNonce],
	);

	// Ключ меняется при изменении состава или порядка панелей.
	// Это заставляет SplitPane перемонтироваться с актуальным порядком после сброса.
	const splitPaneKey = panes
		.map((p) => (p as React.ReactElement)?.key ?? "")
		.join(",");

	return (
		<CampaignWizardFormProvider>
			<div className='chat'>
				<SplitPane
					key={`${splitPaneKey}-${layoutHardResetNonce}`}
					panes={panes}
					direction='horizontal'
					initialPercents={initialPercents.length ? initialPercents : undefined}
				/>
			</div>
		</CampaignWizardFormProvider>
	);
};
